// removed by extract-text-webpack-plugin
module.exports = {"ColumnGroup":"ColumnGroup__ColumnGroup___2r1td","ColumnGroup__ReverseDesktop":"ColumnGroup__ColumnGroup__ReverseDesktop___2smpY","ColumnGroup__ReverseMobile":"ColumnGroup__ColumnGroup__ReverseMobile___2N2Ij","ColumnGroupItem":"ColumnGroup__ColumnGroupItem___2LiIt"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/ColumnGroup/ColumnGroup.less
// module id = 1221
// module chunks = 0 1